module.exports = __webpack_public_path__ + "d5be168a1be2b9e5bc19112ab3abe560.jpg";